export default __webpack_public_path__ + "static/media/ReviewsMagnifyIcon.a7fa6531.svg";